import { ISchool } from './ischool';

export interface ISchoolState {
    selectedSchool: ISchool;
    allSchools: ISchool[];
    Id: string;
}
